<template>
  <CRow>
    <CCol col="4" >
    <CCard>   
    <CCardHeader><b>Personal Info</b> </CCardHeader>
      
      <CListGroup >
        <CListGroupItem href="#"> Name :  {{ datas.data.fullname }} </CListGroupItem>
        <CListGroupItem href="#"> Email :  {{ datas.data.email }} </CListGroupItem>
        <CListGroupItem href="#"> Gender :  {{ datas.data.gender }} </CListGroupItem>
        
        
      </CListGroup>
    </CCard>
    <CCard>   
    <CCardHeader><b>Result</b></CCardHeader>
      <CListGroup >
        <CListGroupItem v-for="item in datas.data.total_result " :key="item.id">
        <div>
        <CRow>
          <CCol class="col-10">
          Point
          </CCol>
          <CCol class="col-2">
          {{  item.nilai}}
          </CCol>
        </CRow>
        <br>
        <CRow v-if="item.nilai >= 5 && item.nilai <= 35">
          <CCol class="col-12">
          You need to keep working on your communication skills. You are not expressing yourself clearly and you may not be receiving messages correctly, either. The good news is that, by paying close attention to the way in which you communicate, you can improve your effectiveness at work and enjoy better working relationships with your colleagues! The rest of this article will direct you to some great tools for improving your communication skills. (Read below to start.)
          </CCol>
        </CRow>
        <CRow v-else-if="item.nilai >= 36 && item.nilai <= 55">
          <CCol class="col-12">
          You're a capable communicator, but you sometimes experience communication problems. Take the time to think about your approach to communication, and focus on receiving messages effectively, as much as sending them. This will help to improve your ability to communicate. (Read below to start.)
          </CCol>
        </CRow>
        <CRow v-else-if="item.nilai >= 56 && item.nilai <= 75">
          <CCol class="col-12">
          Excellent! You understand your role as a communicator, both when you send messages and when you receive them. You anticipate problems, and you choose the right channel to communicate. People respect you for your ability to communicate clearly and they appreciate your listening skills. (Read below for more.)
          </CCol>
        </CRow>
        </div>
        </CListGroupItem>  
         </CListGroup>
    </CCard>
    </CCol>
    <CCol col="8" >
      <CCard>
         <CCardHeader><b>Answer Detail</b></CCardHeader>
          <CCardBody>
            
            <!-- <label>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</label> -->
              
                <table class="mt-3">
                <thead>
                  <tr >
                    <th v-for="item in fields_answer" :key="item.title">
                    {{ item.title }}
                    </th>
                  </tr>
                </thead>
              <tbody>
                <tr style="border-bottom:1px solid grey " v-for="i in datas.data.get_answer" :key="i.id" >
                  <td >{{ i.question }} 
                    
                  </td>
                  <td>{{ i.answer }}</td>
                   </tr>
              </tbody>
              </table>

            
          </CCardBody>
        </CCard>
    </CCol>
 
    <alertmodal></alertmodal>
  </CRow>

</template>

<script>  
import moment from 'moment';
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import onlineclass from '@/services/onlineclass';

import axios from 'axios'

import store from '@/store.js'

export default {
name: 'detailmodal',
components: {  alertmodal },
  data () {
    return {
      accordion: '',
      mode: '',
      datas:[],
      dob:'',
      dad:'',
      mom:'',
      form:{
        uuid:''
      },
      fields_answer:[ 
        {title: 'Question', sortable: false, },
        {title: 'Answer', sortable: false},
      ],
      }
  },
  mounted(){
    this.load()
    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.load();
          console.log('load mounted')  
      }
    });
  },  
  
  beforeDestroy(){
    EventBus.$off('TABLE_UPDATE', this.listener)  
    console.log('OFF_OPEN_MODAL_IKID')
   },
 methods:{

    load(){
        onlineclass.getQuizKomunikasibyID(this.$route.query.id)
        .then(res => {
            this.datas = res;
            
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

        
        
    },
   
    
  }  
}

</script>
